import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

import { MyTenantForm } from "./MyTenantForm";
import { Tenant } from "./Tenant";


export function TenantDashboard() {
  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state.header);

  const [tenants, setTenants] = useState([]);
  const [selectedTenantForEdit, setSelectedTenantForEdit] = useState({});
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = () => {
    setIsLoading(true);
    const requestBody = {
      path: "tenant",
      query: {},
      body: {},
      requestType: "GET",
    };

    axios
      .post(api + `/auth/piggyback`, requestBody, headers)
      .then((response) => {
        const transformedData = (response?.data || []).map((tenant) => ({
          id: tenant.id,
          name: tenant.name,
          domain: tenant.domain,
          createdAt: tenant.createdAt,
          updatedAt: tenant.updatedAt,
        }));
         setTenants(transformedData);
        setErrors(false);
      })
      .catch((e) => {
        setErrors(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

 
  return (
    <div className="mainContainer emms-main-container">
            <header className="no-margin">
                    <figure className="emms-image-figure">
                      <img className="img emm-image" src={'https://storage.googleapis.com/content_ai_bucket_elhitech/content/tenant_banner.png'} alt="Logo" />
                    </figure>
            </header>

             <div className="title-container">
                    <div className="title">
                      
                    </div>
                    <div>
                      <MyTenantForm
                            tenantData={selectedTenantForEdit}
                            setSelectedTenantForEdit={setSelectedTenantForEdit}
                            onSuccess={fetchData}
                        />
                    </div>
                  </div>

      <div
        className="emms-main-container-left-align"
        style={{ marginLeft: "10%" }}
      >
        <Tenant
          errors={errors}
          isLoading={isLoading}
          tenants={tenants}
          setSelectedTenantForEdit={setSelectedTenantForEdit}
        />
      </div>
    </div>
  );
}